import { Text } from "@dxp-feed/ui/Text";
import { Box } from "@dxp-feed/ui/Box";
import React from "react";
import { SiteContainer } from "@/components/Container";

const Heading: React.FC<any> = ({ props }) => {
  return (
    <SiteContainer>
    <Box as="div">
      <Box as="div" className="py-6 lg:pt-12 lg:pb-8">
        <Text as="h2" className="font-raleway  text-xl xs:text-3xl text-center">
          {props?.heading}
        </Text>
      </Box>
    </Box>
    </SiteContainer>
  );
};

export default Heading;
